import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-custom-invoic',
  templateUrl: './edit-custom-invoic.component.html',
  styleUrls: ['./edit-custom-invoic.component.scss']
})
export class EditCustomInvoicComponent implements OnInit {
  form!: FormGroup

  constructor(
    public dialogRef: MatDialogRef<EditCustomInvoicComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      payment_terms: [this.data?.payment_terms ?? ''],
      currency: [this.data?.currency ?? ''],
      tax_id: [this.data?.tax_id ?? ''],
      tax: [this.data?.tax ?? ''],
    })
  }

  save(): boolean | void {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return false
    }
    this.dialogRef.close(this.form.value);
  }

  closed(){
    this.dialogRef.close();
  }

}
